import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import './__mocks__';
import {
  BalanceFinanceFilters,
  BalanceFinanceRow,
  DebtsChartItem,
  SettlementsChartItem,
} from './types/types';

export const balanceFinanceApi = createApi({
  reducerPath: 'balanceFinanceApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/balance-finance`,
  }),
  tagTypes: ['BalanceFinance'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getBalanceFinance: builder.query<
      BalanceFinanceRow[],
      BalanceFinanceFilters
    >({
      query: params => ({
        url: '',
        params,
      }),
      providesTags: ['BalanceFinance'],
    }),
    getDebtsChart: builder.query<DebtsChartItem[], BalanceFinanceFilters>({
      query: params => ({
        url: '/debts-chart',
        params,
      }),
      providesTags: ['BalanceFinance'],
    }),
    getSettlementsChart: builder.query<
      SettlementsChartItem[],
      BalanceFinanceFilters
    >({
      query: params => ({
        url: '/settlements-chart',
        params,
      }),
      providesTags: ['BalanceFinance'],
    }),
  }),
});

export const {
  useGetBalanceFinanceQuery,
  useGetDebtsChartQuery,
  useGetSettlementsChartQuery,
} = balanceFinanceApi;
